import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { plans, type PlanId } from '../../data/pricing';
import { costSections, type CostRow } from '../../data/additionalCosts';
import { CostCell } from './CostCell';
import { QuotedList } from './QuotedList';
export function CostsMobile() {
  const [selected, setSelected] = useState<PlanId>('pilot');
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});
  const plan = plans.find(p => p.id === selected) ?? plans[0];
  const renderRow = (row: CostRow) => <li key={row.label} className="flex items-start justify-between gap-4 px-5 py-4" data-id="element-21" data-mp="2boq0o2ngiq19">
      <div className="min-w-0" data-id="element-22" data-mp="2gly7j735n7n7">
        <p className="text-sm font-semibold text-gray-900" data-id="element-23" data-mp="2gpvrtw1gy58o">{row.label}</p>
        {row.detail && <p className="mt-0.5 text-xs text-gray-500" data-id="element-24" data-mp="2lkj9pc1yw1ea">{row.detail}</p>}
      </div>
      <div className="flex-shrink-0 text-right" data-id="element-25" data-mp="3s26b9bubop0g">
        <CostCell value={row.values[plan.id]} accentClass={plan.accentText} data-id="element-26" data-mp="w4zf12j9rdr" />
      </div>
    </li>;
  return <div className="lg:hidden" data-id="element-27" data-mp="3v0g3d2ya77k1">
      <div className="sticky top-24 z-20 -mx-4 bg-white px-4 py-3 shadow-sm sm:-mx-6 sm:px-6" data-id="element-28" data-mp="3uzmtht4101xo">
        <p className="mb-2 text-xs font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-29" data-mp="3qz2wqqnd70c2">Choose a package</p>
        <div role="radiogroup" aria-label="Package" className="grid grid-cols-4 gap-1.5" data-id="element-30" data-mp="3lxnbaxh9yrt5">
          {plans.map(p => {
          const isActive = p.id === selected;
          return <button key={p.id} type="button" role="radio" aria-checked={isActive} onClick={() => setSelected(p.id)} className={`rounded-md px-1 py-2 text-center transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-1 ${isActive ? p.bandClass : 'bg-gray-50 text-brand-black'}`} data-id="element-31" data-mp="3c2vbro44tuvq">
                <span className="block text-[11px] font-bold uppercase tracking-wide" data-id="element-32" data-mp="2ochrwkvpb2c8">{p.name}</span>
                <span className="block text-xs font-extrabold" data-id="element-33" data-mp="2emstsgnct3qm">{p.price}/mo</span>
              </button>;
        })}
        </div>
      </div>

      <div className="mt-6 space-y-6" data-id="element-34" data-mp="25o7cspxj5wry">
        {costSections.map(section => <section key={section.id} className="overflow-hidden border border-gray-200 shadow-sm" data-id="element-35" data-mp="29or6tkmt4k9v">
            <h2 className="bg-brand-red px-5 py-3 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-36" data-mp="2xevdy1z7f25m">{section.title}</h2>

            {section.rows.length > 0 && <ul className="divide-y divide-gray-200" data-id="element-37" data-mp="32cwry8hrwba8">{section.rows.map(renderRow)}</ul>}

            {section.group && <div className="border-t border-gray-200" data-id="element-38" data-mp="2snvfutecme1j">
                <button type="button" aria-expanded={!!openGroups[section.id]} onClick={() => setOpenGroups(g => ({
            ...g,
            [section.id]: !g[section.id]
          }))} className="flex min-h-[52px] w-full items-center gap-2 bg-gray-50 px-5 py-3 text-left text-sm font-bold text-brand-black focus:outline-none focus-visible:text-brand-red" data-id="element-39" data-mp="2smk9qmxfku79">
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${openGroups[section.id] ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-40" data-mp="14pueupgitc48" />
                  {section.group.title}
                </button>
                {openGroups[section.id] && <ul className="divide-y divide-gray-200 border-t border-gray-200" data-id="element-41" data-mp="qs6101kvf58o">{section.group.rows.map(renderRow)}</ul>}
              </div>}

            {section.quoted && <div className="px-5 py-5" data-id="element-42" data-mp="10mfyfxoo6tq9">
                <QuotedList items={section.quoted.items} line={section.quoted.line} data-id="element-43" data-mp="vp690i1a6i2f" />
              </div>}

            {(section.note || section.footnote) && <p className="border-t border-gray-200 bg-gray-50 px-5 py-3 text-xs leading-relaxed text-gray-600" data-id="element-44" data-mp="274l57jlo15wh">
                {section.note ?? section.footnote}
              </p>}
          </section>)}
      </div>
    </div>;
}